// src/pages/AdminTools.js
import React, { useState } from 'react';
import { httpsCallable } from "firebase/functions";
import { functions } from '../firebase';
import { useAuth } from '../context/AuthContext';

const AdminTools = () => {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('admin');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  const handleSetRole = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      setMessage("Erro: Você precisa estar logado para executar esta ação.");
      return;
    }
    if (!email) {
      setMessage("Erro: Por favor, insira um e-mail.");
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const addUserRoleFunc = httpsCallable(functions, 'addUserRole');
      const result = await addUserRoleFunc({ email, role });
      setMessage(result.data.message);
    } catch (error) {
      console.error("Erro ao definir o cargo:", error);
      setMessage(`Erro: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '40px', maxWidth: '600px', margin: 'auto', background: 'white', borderRadius: '8px' }}>
      <h1>Ferramentas Administrativas</h1>
      <p>Use esta página para atribuir o cargo de administrador ao primeiro usuário do sistema.</p>
      
      <form onSubmit={handleSetRole}>
        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="email" style={{ display: 'block', marginBottom: '5px' }}>E-mail do Usuário</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@exemplo.com"
            style={{ width: '100%', padding: '8px' }}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="role" style={{ display: 'block', marginBottom: '5px' }}>Cargo (Role)</label>
          <select 
            id="role" 
            value={role} 
            onChange={(e) => setRole(e.target.value)}
            style={{ width: '100%', padding: '8px' }}
          >
            <option value="admin">Administrador</option>
          </select>
        </div>
        <button type="submit" disabled={loading} style={{padding: '10px 15px'}}>
          {loading ? 'Definindo...' : 'Definir Cargo'}
        </button>
      </form>

      {message && <p style={{ marginTop: '20px', fontWeight: 'bold' }}>{message}</p>}
    </div>
  );
};

export default AdminTools;